module.exports = __webpack_public_path__ + "static/grapes-color-b768bbf36f944790023ec7bba113abd9.svg";